import React,{useEffect,useRef,useState} from 'react';
import {Play,Pause,Volume2,VolumeX} from 'lucide-react';

const empty={playing:false,muted:true,time:0,duration:0};
const clock=(seconds:number)=>`${Math.floor(seconds/60)}:${String(Math.floor(seconds%60)).padStart(2,'0')}`;

/** Controls stay outside the library's zoom transform. Native iOS video
 * controls have their own pinch-to-fullscreen gesture, so expanded playback
 * uses these controls while the existing Lightbox owns all touch gestures. */
export default function PhotoVideoPlaybackControls(){
 const controls=useRef<HTMLDivElement>(null),player=useRef<HTMLVideoElement|null>(null),[state,setState]=useState(empty);
 useEffect(()=>{
  // The footer is a sibling of Controller, outside both its context and zoom
  // transform. Bind only the media inside this exact lightbox instance.
  const container=controls.current?.closest('.sonata-photo-lightbox');if(!container)return;
  let detach=()=>{};
  const bind=()=>{
   const next=container.querySelector('video');if(next===player.current)return;
   detach();player.current=next;setState(empty);if(!next)return;
   const update=()=>setState({playing:!next.paused&&!next.ended,muted:next.muted,time:Number.isFinite(next.currentTime)?next.currentTime:0,duration:Number.isFinite(next.duration)?next.duration:0});
   const events=['loadedmetadata','durationchange','timeupdate','play','pause','ended','volumechange','seeked','emptied'];
   for(const event of events)next.addEventListener(event,update);update();
   detach=()=>{for(const event of events)next.removeEventListener(event,update);};
  };
  const observer=new MutationObserver(bind);observer.observe(container,{childList:true,subtree:true});bind();
  return()=>{observer.disconnect();detach();player.current=null;};
 },[]);
 const button='min-h-11 min-w-11 inline-flex items-center justify-center rounded-full text-white disabled:opacity-30';
 return <div ref={controls} className="photo-video-playback" role="group" aria-label="Video playback">
  <button type="button" aria-label={state.playing?'Pause video':'Play video'} className={button} disabled={!player.current} onClick={()=>{
   const video=player.current;if(!video)return;if(video.paused||video.ended)void video.play().catch(()=>{});else video.pause();
  }}>{state.playing?<Pause size={20}/>:<Play size={20}/>}</button>
  <span className="photo-video-clock" aria-hidden="true">{clock(state.time)} / {clock(state.duration)}</span>
  <input type="range" min={0} max={state.duration||1} step={0.1} value={Math.min(state.time,state.duration||0)} disabled={!state.duration}
   aria-label="Video position" aria-valuetext={`${clock(state.time)} of ${clock(state.duration)}`} onChange={event=>{
    const video=player.current;if(video&&Number.isFinite(video.duration)&&video.duration>0){video.currentTime=Math.max(0,Math.min(Number(event.target.value),video.duration));setState(value=>({...value,time:video.currentTime}));}
   }}/>
  <button type="button" aria-label={state.muted?'Unmute video':'Mute video'} className={button} disabled={!player.current} onClick={()=>{if(player.current)player.current.muted=!player.current.muted;}}>{state.muted?<VolumeX size={20}/>:<Volume2 size={20}/>}</button>
 </div>;
}
